import { useEffect, useState } from 'react';
import useOrderBookStore from '../orderBook.store';

export const useOrderBookStoreIsHydrated = () => {
  const [isHydrated, setIsHydrated] = useState(false);

  useEffect(() => {
    if (useOrderBookStore.persist.hasHydrated()) {
      setIsHydrated(true);
      return;
    }

    const unsubscribe = useOrderBookStore.persist.onFinishHydration(() => {
      setIsHydrated(true);
    });

    return () => {
      unsubscribe();
    };
  }, []);

  return isHydrated;
};
